import React, { useContext } from 'react';
import router from 'next/router';
import { Button } from '@chakra-ui/react';
import { NavigationContext } from '../../../lib/contexts/NavigationContext';
import useHasLiveEvents from '../../../lib/hooks/useHasLiveEvents';
import NavLink from '../navLink';

type EventBookingNavProps = {
  variant?: 'link'|'button';
  /** Called before navigating, e.g. to close the mobile menu. */
  onNavigate?: () => void;
}

/**
 * "Events" in the site navigation, shown only while the site has events on
 * sale. Between seasons there is nothing to link to, and a link to an empty
 * page reads as something broken.
 */
const EventBookingNav = ({ variant = 'link', onNavigate }: EventBookingNavProps) => {
  const { paths } = useContext(NavigationContext);
  const hasLiveEvents = useHasLiveEvents();

  if (!hasLiveEvents) return null;

  const go = () => {
    onNavigate?.();
    return router.push(paths.events);
  };

  return (variant === 'link' ? (
    <NavLink label="Events" action={go} />
  ) : (
    <Button variant="link" onClick={go}>Events</Button>
  ));
};

export default EventBookingNav;
